import { useContext } from 'react';
import { WizardCompletionContext, WizardCompletionContextValue } from '../contexts/complexContexts';

export const useWizardCompletion = (): WizardCompletionContextValue => {
  const context = useContext(WizardCompletionContext);
  if (!context) {
    throw new Error('useWizardCompletion must be used within WizardCompletionProvider');
  }
  return context;
};
